import { ru } from 'date-fns/locale';

let currentLocale = null;

const dateFnsLocales = { ru };

export const setDateLocale = locale => {
  currentLocale = locale;
};

export const getDateLocale = () => {
  return currentLocale ? dateFnsLocales[currentLocale] : undefined;
};

export const isRu = () => currentLocale === 'ru';
